// extracted by mini-css-extract-plugin
export default {"section":"panel_section__SGzhe","filterContent":"panel_filterContent__M3F0x","menuPanelHeader":"panel_menuPanelHeader__UL+fT","avatarRing":"panel_avatarRing__Rei5n"};